import { RefreshButton, TopToolbar } from 'ra-ui-materialui';
import { FiberNew } from '@mui/icons-material';
import { Button } from 'react-admin';
import { useNavigate } from 'react-router';
import { ADD_ROUTE, ROLE_BIG_CREATE_CONTRACT } from '@/utils/CONST';
import { usePermissions } from 'react-admin';

const ContractsListActions = () => {
    const navigate = useNavigate();
    const { permissions } = usePermissions();

    const navigateToCreateContract = () => {
        navigate(ADD_ROUTE);
    };

    return (
        <TopToolbar sx={{ display: 'flex', alignItems: 'center' }}>
            {permissions?.includes(ROLE_BIG_CREATE_CONTRACT) && (
                <Button onClick={navigateToCreateContract} label={'contract.create.label'}>
                    <FiberNew />
                </Button>
            )}

            <RefreshButton
                data-cy='refresh-button'
                style={{
                    paddingLeft: '12px',
                    paddingRight: '12px',
                }}
            />
        </TopToolbar>
    );
};

export default ContractsListActions;
